import { Component, OnInit, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ColorList } from 'app/bars/topbar/topbarData';
import { TranslateService } from '@ngx-translate/core';
import * as api from '../../shared/api/apihandler';

@Component({
  selector: 'app-case-activity-history',
  templateUrl: './case-activity-history.component.html',
  styleUrls: ['./case-activity-history.component.css']
})
export class CaseActivityHistoryComponent implements OnInit {

  @Input() case: any;
  @Input() view: string;
  activityHistory: Array<ActivityHistory>;
  colorList = ColorList.colors;

  constructor(private http: HttpClient, private route: ActivatedRoute, private router: Router, private translate: TranslateService) { }

  ngOnInit(): void {
    this.getCaseHistory();
  }

  getCaseHistory() {
    let caseId = this.route.snapshot.paramMap.get('id');
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    if (this.view == 'full') {
      this.http.get<Array<ActivityHistory>>(api.jubloApi + 'api/CaseHistory/GetCaseHistory/' + caseId + '/0/1000', { headers }).subscribe({
        next: (data) => {
          // console.log(data);
          this.activityHistory = data;
          this.activityHistory.forEach(x => { x.text = !!x.text ? this.translateText(x.text) : x.text; });
        },
        error: err => console.error(err),
        complete: () => {
          
        }
      });
    } else {
      this.http.get<Array<ActivityHistory>>(api.jubloApi + 'api/CaseHistory/GetCaseHistory/' + caseId + '/0/20', { headers }).subscribe({
        next: (data) => {
          //console.log(data);
          this.activityHistory = data;
          this.activityHistory.forEach(x => { x.text = !!x.text ? this.translateText(x.text) : x.text; });
        },
        error: err => console.error(err),
        complete: () => {
        }
      });
    }
  }

  translateText(inputText: string) {
    let split = inputText.split(' ').filter(Boolean);
    let result = '';
    split.forEach(x => { result = result + this.translate.instant(x) + ' '; });
    return result;
  }

  findColor(type, name) {
    if (!!name) {
      let init = name.trim().substring(0, 1).toUpperCase();
      switch (type) {
        case 'b':
          if (!!init) {
            return ColorList.colors[init].background;
          } else {
            return '#80b8f2';
          }
        case 'c':
          if (!!init) {
            return ColorList.colors[init].color;
          } else {
            return 'white';
          }
        default:
          if (!!init) {
            return init;
          } else {
            return '';
          }
      }
    } else {
      return;
    }
  }

  showText(x, type) {
    if (type == 'translate') {
      return x.translateText != 'Activity.CaseChannelChange' && 
      x.translateText != 'Activity.CaseStageChange' && 
      x.translateText != 'Activity.SetPropertyToCase' && 
      x.translateText != 'Activity.SetPropertyLeaseToCase' && 
      x.translateText != 'Activity.PriorityChange' && 
      x.translateText != 'Activity.ResponsibleRemoved' && 
      x.translateText != 'Activity.OfferRejected' && 
      x.translateText != 'Activity.OfferAccepted' && 
      x.translateText != 'Activity.OfferPipeline' &&
      x.translateText != 'Activity.OfferDeselected' &&
      x.translateText != 'Activity.OfferNew' &&
      x.translateText != 'Activity.ResponsibleChangedTo' ? true : false;
    }

    if (type == 'text') {
      return x.translateText == 'Activity.CaseChannelChange' || 
      x.translateText == 'Activity.CaseStageChange' || 
      x.translateText == 'Activity.SetPropertyToCase' || 
      x.translateText == 'Activity.SetPropertyLeaseToCase' || 
      x.translateText == 'Activity.PriorityChange' || 
      x.translateText == 'Activity.ResponsibleRemoved' || 
      x.translateText == 'Activity.OfferRejected' || 
      x.translateText == 'Activity.OfferAccepted' || 
      x.translateText == 'Activity.OfferPipeline' || 
      x.translateText == 'Activity.OfferDeselected' || 
      x.translateText == 'Activity.OfferNew' || 
      x.translateText == 'Activity.ResponsibleChangedTo' ? true : false;
    }
  }

  switchTab() {
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: { tab: 'activityHistory' },
        queryParamsHandling: 'merge'
      });
  }

}

export class ActivityHistory {
  name: string;
  icon: string;
  text: string;
  subText: string;
  translateText: string;
  createdAt: string;
}